export default __webpack_public_path__ + "static/media/NYAS.1a5d75d3.png";